export default {
  button: {
    confirm: "确认",
    cancel: "取消",
    create: "创建",
  },
  search: "搜索",
  edit: "编辑",
  create: "创建",
  userName: "用户名称",
  password: "密码",
  information: "提示",
  deleteSuccess: "删除成功!",

  route: {
    dashboard: "Index",
    documentation: "文档",
    guide: "引导页",
    permission: "权限测试页",
    rolePermission: "角色权限",
    pagePermission: "页面权限",
    directivePermission: "指令权限",
    icons: "图标",
    components: "MemoryMap",
    tinymce: "富文本编辑器",
    markdown: "Markdown",
    jsonEditor: "JSON 编辑器",
    dndList: "待定",
    splitPane: "Splitpane",
    avatarUpload: "头像上传",
    dropzone: "Dropzone",
    sticky: "Sticky",
    countTo: "Count To",
    componentMixin: "小组件",
    backToTop: "返回顶部",
    dragDialog: "拖拽 Dialog",
    dragSelect: "查询表格",
    dragKanban: "待定",
    charts: "SoC Generator",
    keyboardChart: "SoC画布",
    lineChart: "CRG Gen",
    mixChart: "CSR Gen",
    PINMUXGen: "PINMUX Gen",
    MemoryMap: "MemoryMap",
    MemoryWraper: "Memory Wraper",
    example: "Regression & Debug",
    nested: "RISC-V Core Generator",
    menu1: "微架构",
    "menu1-1": "Core-Base Options",
    "menu1-2": "Memory-Path Options",
    "menu1-2-1": "菜单 1-2-1",
    "menu1-2-2": "菜单 1-2-2",
    "menu1-3": "Core-Auxiliary Options",
    "menu1-4": "Core-Advanced Options",
    "menu1-5": "Implement-Related Options",
    menu2: "定制指令与编译工具链",
    menu3: "基础计算库",
    Table: "Test Generator",
    dynamicTable: "Core delivery test generator",
    dragTable: "Core UVM complex test",
    inlineEditTable: "Core special test editor",
    complexTable: "SoC delivery test generator",
    SoCEditor: "SoC special test editor",
    FaultInjectGenerator: "Fault Inject Generator",
    tab: "Tab",
    form: "表单",
    ipuvm: "IP UVM complex test",
    createArticle: "回归配置与编辑",
    defectManagement: "缺陷管理",
    editArticle: "Waveform Debug",
    articleList: "回归结果管理",
    caseArticle: "CASE结果管理",
    baseArticle: "基础配置",
    wavedrom: "wavedrom",
    errorPages: "OS & BSP Generator",
    page401: "OS porting",
    page404: "BSP Generator",
    applicationEditor: "Application editor",
    errorLog: "错误日志",
    excel: "Excel",
    exportExcel: "导出 Excel",
    selectExcel: "导出 已选择项",
    mergeHeader: "导出 多级表头",
    uploadExcel: "上传 Excel",
    zip: "Zip",
    pdf: "PDF",
    exportZip: "Export Zip",
    theme: "换肤",
    clipboardDemo: "Clipboard",
    i18n: "国际化",
    externalLink: "外链",
    profile: "个人中心",
    upload_success: "上传成功",
  },

  profile: {
    newProject: "新项目",
    joinProject: "加入项目",
    projectName: "项目名称",
    editProfile: "编辑简介",
    projectInfo: "项目信息",
    gitInfo: "Git 信息",
    member: "成员",
    default: "默认",
    dissolve: "解散",
    setAsDefault: "设置为默认",
    form: {
      inviteCode: "邀请码",
      invite: "邀请",
      approval: "审批",
      createBy: "创建人",
      createTime: "创建时间",
      email: "邮箱",
      role: "角色",
      status: "状态",
      allowed: "允许",
      refused: "拒绝",
      name: "名称",
      role: {
        role: "角色",
        architecture: "设计工程师",
        hardware: "硬件工程师",
        verify: "验证工程师",
        software: "软件工程师",
        backEndEngineer: "后端工程师",
      },
      rule: {
        tooltip: {
          projectName: "项目名称必填",
          gitAddress: "git地址必填",
          gitUsername: "git账户必填",
          gitPassword: "git密码必填",
        },
      },
    },
    userCard: {
      name: "名称",
      updatePassword: "修改密码",
    },
    account: {
      currentPassword: "当前密码",
      newPassword: "新密码",
      confirmPassword: "确认密码",
      updatePassword: "修改密码",
      currentPasswordInfo: "请输入当前帐号密码",
      newPasswordInfo: "新密码和当前密码不能相同",
      confirmPasswordInfo: "确认密码和新密码保持一致",
      cancel: "取消",
      submit: "提交",
      updateSuccessfully: "更新密码成功,请重新登录",
    },
    project: {
      createProject: "创建项目",
      name: "项目名称",
      gitAddress: "Git 地址",
      gitUserName: "Git 账户",
      gitPassword: "Git 密码 / Token (推荐使用 token) ",
      editMode: "编辑模式",
    },
  },
  navbar: {
    dashboard: "index",
    github: "项目地址",
    logOut: "退出登录",
    profile: "个人中心",
    theme: "换肤",
    size: "布局大小",
  },
  account: {
    username: "账号",
    password: "密码",
    email: "邮箱",
    phone: "手机",
  },

  login: {
    title: "系统登录",
    logIn: "登录",
    forgotPassword: "忘记密码?",
    rememberMe: "记住我",
    register: "注册",
    resetPassword: "重置密码",
    registeredSuccessfully: "注册成功，将跳转至首页进行登录",
    resetSuccessfully: "重置密码成功,请重新登录",
    cancel: "取消",
    registerInfo: "还没有帐号，立刻去",
    username: "账号",
    password: "密码",
    any: "随便填",
    thirdparty: "第三方登录",
    thirdpartyTips: "本地不能模拟，请结合自己业务进行模拟！！！",
  },
  register: {
    confirm: "确认密码",
    placeholder: {
      enterUsername: "请输入帐号",
      enterEmail: "请输入邮箱地址",
      enterEmailAddr: "请输入合理的邮箱地址",
      enterPassword: "请输入密码",
      enterPhonenumber: "请输入手机号",
      confirmPassword: "请确认密码",
      pwdNotMatch: "两次密码输入不一致，请重新输入",
    },
    agreementInfo: "我已阅读并同意",
    agreementContent: "开芯云平台用户服务协议和隐私政策",
    agreeAndContinue: "同意并继续",
    needToAgreeInfo: "需要同意协议后再进行注册",
  },
  documentation: {
    documentation: "文档",
    github: "Github 地址",
  },
  permission: {
    addRole: "新增角色",
    editPermission: "编辑权限",
    roles: "你的权限",
    switchRoles: "切换权限",
    tips: "在某些情况下，不适合使用 v-permission。例如：Element-UI 的 el-tab 或 el-table-column 以及其它动态渲染 dom 的场景。你只能通过手动设置 v-if 来实现。",
    delete: "删除",
    confirm: "确定",
    cancel: "取消",
  },
  guide: {
    description:
      "引导页对于一些第一次进入项目的人很有用，你可以简单介绍下项目的功能。本 Demo 是基于",
    button: "打开引导",
  },
  components: {
    documentation: "文档",
    tinymceTips:
      "富文本是管理后台一个核心的功能，但同时又是一个有很多坑的地方。在选择富文本的过程中我也走了不少的弯路，市面上常见的富文本都基本用过了，最终权衡了一下选择了Tinymce。更详细的富文本比较和介绍见",
    dropzoneTips:
      "由于我司业务有特殊需求，而且要传七牛 所以没用第三方，选择了自己封装。代码非常的简单，具体代码你可以在这里看到 @/components/Dropzone",
    stickyTips: "当页面滚动到预设的位置会吸附在顶部",
    backToTopTips1: "页面滚动到指定位置会在右下角出现返回顶部按钮",
    backToTopTips2:
      "可自定义按钮的样式、show/hide、出现的高度、返回的位置 如需文字提示，可在外部使用Element的el-tooltip元素",
    imageUploadTips:
      "由于我在使用时它只有vue@1版本，而且和mockjs不兼容，所以自己改造了一下，如果大家要使用的话，优先还是使用官方版本。",
  },
  table: {
    dynamicTips1: "固定表头, 按照表头顺序排序",
    dynamicTips2: "不固定表头, 按照点击顺序排序",
    dragTips1: "默认顺序",
    dragTips2: "拖拽后顺序",
    title: "标题",
    importance: "重要性",
    type: "类型",
    remark: "点评",
    search: "搜索",
    add: "添加",
    export: "导出",
    reviewer: "审核人",
    id: "序号",
    date: "时间",
    author: "作者",
    readings: "阅读数",
    status: "状态",
    actions: "操作",
    edit: "编辑",
    publish: "发布",
    draft: "草稿",
    delete: "删除",
    cancel: "取 消",
    confirm: "确 定",
    regressionList: "回归List",
    regressionDate: "回归时刻",
    regressionResult: "回归结果",
    compilerFailNum: "编译是否成功",
    simulateFailNum: "仿真失败个数",
    simulateFailList: "仿真失败列表",
    simulateWaveForm: "仿真失败波形",
    process: "仿真进度",
    viewWave: "查看波形",
    regressionName: "回归名称",
    rtlVersion: "rtl版本",
    rtlType: "rtl类型",
    caseName: "case名称",
    caseNum: "case数量",
    viewResult: "查看失败CASE结果",
    caseType: "CASE类型",
    caseCommand: "CASE复现命令",
    isFixed: "是否完成FIX",
    rerunCase: "重新仿真CASE",
    relatedLog: "相关Log",
    userName: "提交人",
    view: "点击查看",
    project: "工程名称",
    gitAddress: "git地址",
    gitUser: "git用户名",
    gitPassword: "git密码",
    projectPath: "文件路径",
    delRepo: "删除repo",
  },
  example: {
    warning:
      "创建和编辑页面是不能被 keep-alive 缓存的，因为keep-alive 的 include 目前不支持根据路由来缓存，所以目前都是基于 component name 来进行缓存的。如果你想类似的实现缓存效果，可以使用 localStorage 等浏览器缓存方案。或者不要使用 keep-alive 的 include，直接缓存所有页面。详情见",
    bug: {
      titleInfo: "输入完title后，按回车以应用。",
      createBug: "创建 Bug",
      manager: "管理",

      form: {
        scope: "范围",
        branch: "分支",
        commitID: "提交ID",
        newScope: "新范围",
        label: "标签",
        title: "标题",
        assigner: "指定人",
        severity: "严重程度",
        priority: "优先级",
        createItem: "创建 Bug",
        status: "状态",
        Open: "打开",
        NotStarted: "未开始",
        Running: "进行中",
        Completed: "已完成",
        WaitVerify: "待验证",
        createTime: "创建时间",
        finishTime: "完成时间",
        severityStatus: "严重",
        normal: "一般",
        minor: "轻微",
        IU: "重要且紧急",
        INU: "重要但不紧急",
        UNI: "不重要但紧急",
        NINU: "不重要不紧急",
        assigner: "分配人",
        assignee: "执行人",
        description: "描述",
        reply: "回复",
      },
      branch: {
        branch: "分支",
        addBranch: "创建分支",
        updateBranch: "更新分支",
        placeholder: "请输入分支",
        description: "描述",
        nullInfo: "分支名称不允许为空",
        nullAndDuplicatedInfo: "分支名称为空或者重复",
        indexCanNotEditInfo: "次序不允许编辑",
        defaultName: "默认名称",
        defaultDesc: "默认描述",
        notDuplicatedNameInfo: "分支名称不允许重复:",
      },

      placeholder: {
        selectLabel: "请选择一个标签",
        enterTitle: "请输入bug标题",
        enterCommitID: "请输入提交ID",
        selectAssigner: "请选择分配人",
        selectAssignee: "请选择执行人",
        selectSeverity: "请选择严重程度",
        selectPriority: "请选择优先级",
        enterSearch: "请输入搜索内容",
        selectScope: "请选择范围",
        selectBranch: "请选择分支",
        enterBranchDesc: "请输入分支描述",
      },
      formRulesMessage: {
        title: "请填充标题内容",
        label: "请选择标签内容",
      },
      confirm: {
        deleteTag: "是否删除该标签?",
        deleteBranch: "是否删除该分支?",
      },
    },
  },
  errorLog: {
    tips: "请点击右上角bug小图标",
    description:
      "现在的管理后台基本都是spa的形式了，它增强了用户体验，但同时也会增加页面出问题的可能性，可能一个小小的疏忽就导致整个页面的死锁。好在 Vue 官网提供了一个方法来捕获处理异常，你可以在其中进行错误处理或者异常上报。",
    documentation: "文档介绍",
  },
  excel: {
    export: "导出",
    selectedExport: "导出已选择项",
    placeholder: "请输入文件名(默认excel-list)",
  },
  zip: {
    export: "导出",
    placeholder: "请输入文件名(默认file)",
  },
  pdf: {
    tips: "这里使用   window.print() 来实现下载pdf的功能",
  },
  theme: {
    change: "换肤",
    documentation: "换肤文档",
    tips: "Tips: 它区别于 navbar 上的 theme-pick, 是两种不同的换肤方法，各自有不同的应用场景，具体请参考文档。",
  },
  tagsView: {
    refresh: "刷新",
    close: "关闭",
    closeOthers: "关闭其它",
    closeAll: "关闭所有",
  },
  settings: {
    title: "系统布局配置",
    theme: "主题色",
    tagsView: "开启 Tags-View",
    fixedHeader: "固定 Header",
    sidebarLogo: "侧边栏 Logo",
  },
  system: {
    name: "系统管理",
    user: "用户管理",
    role: "角色管理",
    menu: "菜单管理",
    dept: "项目管理",
    dict: "字典",
  },
};
